import { Controller } from "@hotwired/stimulus"

// Keeps app-card link navigation from firing when opening the settings menu.
export default class extends Controller {
    stopPropagation(event) {
        event.stopPropagation()
    }
}
